<template>
     <v-app :dark='darkMode'>
    <v-container grid-list-md>
        <v-breadcrumbs large :items="items" divider=">"></v-breadcrumbs>
        <template>
        <v-layout>
            <v-flex  sm10 offset-sm1>
            <v-card>
                <v-container fill-height fluid>
                    <v-layout fill-height>
                    <v-flex xs12 align-end flexbox>
                        <span class="headline">Testing Summary:</span>
                        <v-btn target='_blank' href='https://firebasestorage.googleapis.com/v0/b/genetic-trust-dev.appspot.com/o/assets%2FEDITED.pdf?alt=media&token=44c712d2-4338-42d6-b899-5baa03511fd0' text color="blue">View Report</v-btn>
                        <v-btn title='night mode' @click='darkMode? darkMode = false : darkMode = true' icon>
                        <v-icon>brightness_3</v-icon>
                        </v-btn>
                    </v-flex>
                    </v-layout>
                </v-container>
                           
                <v-card-title>
                <div>                    

                       <blockquote class="blockquote"><span class='headline font-weight-bold'>Summary</span><br>
                <ol>
                <li class='ma-2 '>Your results identified a pathogenic variant in the <span class='font-italic'>BRCA2</span> gene.</li>
                <li class='ma-2'><span class='font-italic'>BRCA2</span> pathogenic variants are associated with an increased risk to develop certain types of cancer including prostate, breast, ovarian and pancreatic.</li>
                 <li class='ma-2 '>This result may influence healthcare recommendations and treatment options. </li>
                 <li class='ma-2 '>Information about your test results may be important for your relatives and have implications for their healthcare.</li>
                 <li class='ma-2 '>There were no other pathogenic or likely pathogenic variants seen in any of the other genes that were analyzed.</li>
                </ol>
            </blockquote>


                    
                
                     <blockquote class="font-weight-medium blockquote">A summary of the pathogenic, likely pathogenic and variants of unknown significance are included below.
                     </blockquote>

                     <blockquote class="blockquote">According to the records that you provided, you underwent genetic testing through <span class='font-weight-black'>Myriad Genetics Laboratory</span> on <span class='font-weight-black'>June 9, 2019.</span></blockquote>


                     <blockquote class="blockquote">This testing analyzed the following genes for variants: <span class='font-weight-black font-italic'>BRCA1</span> and <span class='font-weight-black'><span class='font-italic'>BRCA2</span>.</span></blockquote>

                    <v-list three-line>
             <v-subheader>
              Pathogenic Variant Identified:
            </v-subheader>
                    <v-list-item class='ma-3 red white--text'>
            <v-list-item-action title='open'>
             <v-icon color='white' size='40px'>add_circle_outline</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              
                 <v-list-item-title class='white--text'>Result : Positive
                </v-list-item-title>
              <v-list-item-title  class='white--text'>Gene Name: <span class='font-italic'>BRCA2</span>
                </v-list-item-title>
              <v-list-item-title title='Variant Name: c.4741delGinsAA (p.Glu1581Lysfs)' class='white--text'>Variant Name: c.4741delGinsAA (p.Glu1581Lysfs)
                </v-list-item-title>
                <v-list-item-sub-title class='white--text'>Variant Classification: Pathogenic</v-list-item-sub-title>
                
            </v-list-item-content>
           <v-list-item-action >
                <v-list-item-sub-title class='white--text'>Variant ID:  266830</v-list-item-sub-title>
              </v-list-item-action>
          </v-list-item>
         </v-list>

                </div>
                </v-card-title>
            <v-card-text>
               
              <blockquote class="subheading blockquote"><span class='headline font-weight-bold'>The <span class='font-italic'>BRCA2</span> Gene</span><br><span>Last updated 06-27-2019</span><br>
              <blockquote class="blockquote">
                   Each of us carry two copies of the gene known as <span class='font-italic'>BRCA2</span>. When this gene is working properly, it makes a protein that helps to protect us from developing certain types of cancer by repairing damage that occurs in our cells over time.
              </blockquote>
              <blockquote class="blockquote">
                   Our genes are in pairs because we inherit one copy from each parent. Most people inherit a working copy from both their mother and working copy from their father. Some people inherit a copy of the <span class='font-italic'>BRCA2</span> gene from either their mother or father with a pathogenic variant (a typo in the DNA code of the gene) that prevents the gene from being read properly by the body. Pathogenic variants are also called mutations.  Individuals who have only one working copy of the <span class='font-italic'>BRCA2</span> gene have an increased chance to develop cancer. 
              </blockquote>
              <blockquote class="blockquote">
                   <span class='font-italic'>BRCA2</span> was named because when it was discovered it was determined that it played an important role in breast cancer. The BR is for “breast” and the CA is for “cancer”. The “2” is assigned because it was the second gene discovered that plays an important role in breast cancer. There is also a gene known as <span class='font-italic'>BRCA1</span> (the first gene discovered that plays a role in breast cancer.
              </blockquote>
              <blockquote class="blockquote">
                  While variants in the <span class='font-italic'>BRCA2</span> gene were first discovered to play a role in increasing the risk for breast cancer, we now know that pathogenic variants in this gene increase the cancer risk for many different types of cancer, for both men and women.  The associated chance to develop certain types of cancer for both men and women are outlined below:
              </blockquote>

               <v-data-table
               disable-initial-sort
               hide-default-footer
                :headers="headers"
                :items="data"
                text>
                <template v-slot:headers="props">
                <tr>
                    <th 
                    v-for="header in props.headers"
                    :key="header.text"
                    :class="['body-2 text-center column sortable', pagination.descending ? 'desc' : 'asc', header.value === pagination.sortBy ? 'active' : '']"
                    @click="changeSort(header.value)"
                    >
                    <v-icon small>arrow_upward</v-icon>
                    {{ header.text }}
                    </th>
                </tr>
                </template>
                <template v-slot:items="props">
                <td class="body-2 text-center">{{ props.item.type }}</td>
                <td class="body-2 text-center">{{ props.item.risk }}</td>
                <td class="body-2 text-center">{{ props.item.brca2 }}</td>
                </template>
            </v-data-table>

                
              
              </blockquote>
              
               <blockquote class="blockquote"><span class='headline font-weight-bold'>Recommendations for Screening</span><br>
               <blockquote class="blockquote">
                  <a href='https://www.nccn.org/' target='_blank'>The National Comprehensive Cancer Network</a>® (NCCN®) is a not-for-profit alliance of 28 leading cancer centers devoted to patient care, research, and education. Each year the NCCN reviews the medical literature and updates recommendations for the best care for people with <span class='font-italic'>BRCA2</span> pathogenic or likely pathogenic variants.
              </blockquote>
              <blockquote class="blockquote">
                  The following recommendations are from the guideline Genetic/Familial High-Risk Assessment: Breast and Ovarian Version 3.2019, published on January 18, 2019
              </blockquote>
                <blockquote class='blockquote'>

                     <v-expansion-panel>
                    <v-expansion-panel-content
                    v-for="(item,index) in tabData"
                    :key="index"
                    >
                    <template v-slot:header>
                        {{item.name}}
                    </template>
                    <v-card>
                        <v-card-text v-html="item.text"></v-card-text>
                    </v-card>
                    </v-expansion-panel-content>
                </v-expansion-panel>
                </blockquote>

                <span class='headline font-weight-bold'>Recommendations for Cancer Treatment</span><br>
                 <blockquote class='blockquote'>
                     <a href='https://www.nccn.org/' target='_blank'>The National Comprehensive Cancer Network</a>® (NCCN®) is a not-for-profit alliance of 28 leading cancer centers devoted to patient care, research, and education. Each year the NCCN reviews the medical literature and updates recommendations for the best care for people with <span class='font-italic'>BRCA2</span> pathogenic or likely pathogenic variants.
                 </blockquote>
                 <blockquote class='blockquote'>
                     The following recommendations are from the guideline version 2.2019 for Prostate Cancer:  
                 </blockquote>
                 <blockquote class='blockquote'>
                     Genetic testing for pathogenic variants related to inherited cancer risk should be considered in men with prostate cancer. Results may be helpful for genetic counseling and also for consideration of optimal chemotherapy regimen. Eligibility for clinical trials may also be determined through the results of genetic testing.  Click here to learn more about clinical trials. 
                 </blockquote>
                
              </blockquote>
            </v-card-text>
    
            </v-card>
            </v-flex>
        </v-layout>
        </template>
    </v-container>
     </v-app>
</template>

<script>
export default {
    data(){
        return{
             pagination: {
             sortBy: 'type'
            },
            darkMode : false,
             headers: [
          { text: 'Cancer Type',value: 'type' },
          { text: 'General Population Risk', value: 'risk' },
          { text: 'Risk due to BRCA2 Pathogenic Variant', value: 'brca2' },
        
        ],
        data : [{type : "Female breast",risk : "12%", brca2 : "50-70%"},
        {type : "Ovarian",risk : "1-2%", brca2 : "12%-20%"},
        {type : "Male breast",risk : "0-1%", brca2 : "7%"},
         {type : "Prostate",risk : "15-18%", brca2 : "20%-30%"},
          {type : "Pancreatic",risk : "0.5%", brca2 : "3%-5%"},
           {type : "Melanoma",risk : "1-2%", brca2 : "3%-5%"},
          ],
          tabData : [
              {name : "For women",text : "<blockquote class='blockquote'>Regarding breast cancer risk, women may decide that more frequent screening for breast cancer with the goal of detecting breast cancer at an early and more treatable stage is best. For women who elect more frequent screening the following is recommended:</blockquote><blockquote class='blockquote'><ul><li>Beginning at age 18 years old: women should be familiar with their breasts and what is normal for them. They should promptly report changes to their health care provider. Checking your breasts each month at the end of your period may be helpful.</li>Beginning at age 25 years: your healthcare provider should perform a breast exam once or twice per year.</li><li>Beginning at age 25–29 years: women should consider breast MRI screening each year with contrast.<li>Beginning at age 30–75 years: women should undergo annual mammogram.</li><li>For women older age 76 and older: management should be considered on an individual basis.</li><li>For women with a BRCA pathogenic/likely pathogenic variant who are treated for breast cancer and have not had a bilateral mastectomy, screening with annual mammogram and breast MRI should continue as described above.</li></ul></blockquote><blockquote class='blockquote'>Some women feel that they would consider surgery, to remove their breast tissue (mastectomy) and reduce their risk to develop breast cancer. This surgery is called a “risk-reducing mastectomy”. This significantly reduces the risk of breast cancer for women who carry a <span class='font-italic'>BRCA1</span> pathogenic. Some women who elect to have this surgery will also undergo breast reconstruction. Some women do not.</blockquote><blockquote class='blockquote'>Regarding ovarian cancer risk, unfortunately there are not yet tests that can reliably detect this type of cancer at an early stage. For this reason, it is recommended that women with a <span class='font-italic'>BRCA1</span> pathogenic variant consider undergoing surgery to remove their ovaries (and fallopian tubes). This is typically recommended between age 35 and 40 years of age but these recommendations may vary depending on plans for children, and the family history.</blockquote><blockquote class='blockquote'>There is currently some evidence that suggests a possible increased risk for uterine cancer for women who carry <span class='font-italic'>BRCA1</span> pathogenic variants. For this reason, it is recommended that women discuss the pros and cons of removal of the uterus (hysterectomy) at the same time the ovaries and fallopian tubes are removed.</blockquote><blockquote class='blockquote'>For women who delay surgery to remove their ovaries, a screening blood test called, CA-125 and ulltrasound may be considered however this has not been proven effective as a strategy for early detection of ovarian cancer.</blockquote>"},
              {name : "For men",text : "<ul><li>Beginning at age 35 years: men should begin breast self exams and follow-up promptly with any changes. They should undergo an annual physical exam including breast exam with their healthcare provider every year.</li><li>Starting at age 45 years: Men should consider beginning annual screening for prostate cancer.</li></ul>"},
              {name : "For men and women",text : "<ul><li>Education regarding signs and symptoms of cancer(s), especially those associated with BRCA gene pathogenic/likely pathogenic variants.</li><li>Screening for pancreatic cancer and melanoma may be considered based on family history.</li></ul>"},
              {name : "Risk to Relatives",text : "<ul><li>Advise about possible inherited cancer risk to relatives</li><li>Recommend genetic counseling</li><li>Consideration of genetic testing for relatives</li></ul>"},
          ],
        items: [
        {
          text: 'Home',
          disabled: false,
          to: '/home'
        },
        {
          text: 'Genetic Testing Result',
          disabled: true,
        
        }],
        trialData : null
        }
    },
    mounted(){
     
    },
    methods:{
       changeSort (column) {
          
        if (this.pagination.sortBy === column) {
          this.pagination.descending = !this.pagination.descending
        } else {
          this.pagination.sortBy = column
          this.pagination.descending = false
        }
      }
    }
}
</script>
